import React, { useState } from 'react';
import TabbedViewWithDateSelect from '../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect';
import { JLR_PLANT } from '../../constants';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import LineFeature from '../../components/LineFeature/LineFeature';

const LineFeatureConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [lineFeatureCount, setLineFeatureCount] = useState(0);

  const title = 'Line Feature Configurator';

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: 'Line Feature',
            title,
            count: lineFeatureCount,
            countColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            backgroundColor:
              plant.label === JLR_PLANT ? 'green' : 'blue',
            component: LineFeature,
            props: {
              handleCountChange: setLineFeatureCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default LineFeatureConfigurator;